module.exports = __webpack_public_path__ + "img/logo_ncg.2d930305.png";